// extracted by mini-css-extract-plugin
export default {"container":"Tn-z","bubbleNav":"Un-z","graphic":"Vn-z","contact":"Wn-z"};